module.exports = __webpack_public_path__ + "img/attribute3.25465eed.png";